import { render, staticRenderFns } from "./gift-picker.vue?vue&type=template&id=d27119bc&scoped=true"
import script from "./gift-picker.vue?vue&type=script&lang=js"
export * from "./gift-picker.vue?vue&type=script&lang=js"
import style0 from "./gift-picker.vue?vue&type=style&index=0&id=d27119bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8d78c4fc2b2e880cb3796fb82bca3a94/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27119bc",
  null
  
)

export default component.exports